/*eslint-disable */
import axios from 'axios';
const $ = window.jQuery = require('jquery');
import videoSocketRef from "@/videoNotificationSocket";
import {
  mapGetters
} from 'vuex';
import {bus} from '@/main';  
import moment from 'moment';
var patientChatScoket;
export default {
  name: 'chat-of-patient',
  components: {},
  props: ['chateRoomIdOfPateint', 'checkingTabOfPatient'],
  data () {
    return {
      selfUserId:'',
      chatWithPatientId:'',
      patientChatDetailResults:[],
      selection_type: 'press_enter',
      checkingActvTabId:'',
      patientChatRoomId:'',
      selfUserInfo:null,
      typingUserInfoState:null,
      msgApiLoader:false,
      msgNextPageLoader:''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    if(patientChatScoket && patientChatScoket.readyState) {
      patientChatScoket.close();
    }
    this.checkingActvTabId = this.checkingTabOfPatient
    this.chatWithPatientId = this.chateRoomIdOfPateint.id
    this.createRoomWithPatient(this.selfUserId, this.chatWithPatientId)
    bus.$on('TypingEventForSelectedUserBus', (data) => {
      this.typingUserInfoState = data
      if (data.message == 'stop') {
        this.typingUserInfoState = null;
      }
    })
    // Msg Loading Method Here
    var _self = this
    $('#chat_msg_list_scroll').on("scroll", function () {
      var yScrollHeight;
      var elmntList = document.getElementById("chat_msg_list_scroll");
      yScrollHeight = elmntList.scrollHeight
      if (0 == $('#chat_msg_list_scroll').scrollTop()) {
        if (_self.msgNextPageLoader) {
          _self.msgApiLoader = true
          axios.get(_self.msgNextPageLoader).then((response) => {
            _self.msgNextPageLoader = ''
            if (response.status == '200') {
              _self.msgNextPageLoader = response.data.data.next
              _self.msgApiLoader = false
              _self.patientChatDetailResults = [].concat(_self.patientChatDetailResults, response.data.data.results);
              // _self.chatRepeatedDateList = [].concat(response.data.data.repeated_dates_arr);
              setTimeout(() => {
                var recentScrlHeight = elmntList.scrollHeight
                elmntList.scrollTop = recentScrlHeight - yScrollHeight
              }, 10)
            }
          }).catch((err) => {
          })
        }
      }
    });
  },
  methods: {
    /*
    * This Will Scroll Bottom Of ChatBox
    */
    chatScrollBottomMethod() {
      var elmnt = document.getElementById("chat_msg_list_scroll");
      var y = elmnt.scrollHeight;
      var scrollH = elmnt.clientHeight;
      var scrollTop = elmnt.scrollTop
      var FullSH = scrollH + scrollTop
      var scrollD = y - FullSH
      if (parseInt(60) > scrollD) {
        $('#chat_msg_list_scroll').animate({ scrollTop: y }, 20)
      }
    },
    newline(){},
    send(){},
    enabledYearDateFun(msgDateTime) {
      var currentLocalDate = moment().format('YYYY');
      var startDateCheck = moment(msgDateTime).format('YYYY')
      if (currentLocalDate > startDateCheck) {
        return true;
      } else {
        return false;
      }
    },
    createRoomWithPatient(selfUserId, patientId){
      let data = {
        users: [selfUserId, patientId],
        is_support_chat: false
      }
      this.$store.dispatch('createChatRoomForPatientMethod', {data:{id:selfUserId,data:data}}).then((res) => {
        var createdRoomChatId = res.data.data.id
        this.patientChatRoomId = createdRoomChatId.replace(/-/g, "")
        this.$store.dispatch('getChatRoomDetailForPatientMethod', { id: createdRoomChatId }).then((response) => {
          this.msgNextPageLoader = response.data.data.next
          this.patientChatDetailResults = [].concat(response.data.data.results)
          this.chatScrollAlwaysBottomMethod()
          // Chat With patient Socket Init
          var __self = this
          var messagesList = document.getElementById('reply_msg_list')
          patientChatScoket = new WebSocket(
            'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
            '/ws/patient-chat/' + this.patientChatRoomId + '/'
          );
          
          // Action On Live Socket
          setTimeout(() => {
            var timeout;
            // Message Send Features Code Here
            document.querySelector('#chat-message-reply-input').onkeyup = function (event) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              if (__self.selection_type == 'press_enter') {
                __self.msgValue = messageInputDom.value;
                if (event.keyCode === 13) {
                  if (event.shiftKey) {
                    event.stopPropagation();
                  }else if (!event.shiftKey) {
                    event.preventDefault();
                    document.querySelector('#chat-message-reply-submit').click();
                  }
                }else {
                  if (messageInputDom.value.length > 0) {
                    videoSocketRef.emit({
                      type: "TypingEventForSelectedUser",
                      message: 'typing',
                      selfUserID:selfUserId,
                      targetForChatUserId:patientId,
                      second_user_id: patientId
                    });
                    clearTimeout(timeout)
                    timeout = setTimeout(() => {
                      videoSocketRef.emit({
                        type: "TypingEventForSelectedUser",
                        message: 'stop',
                        selfUserID:selfUserId,
                        targetForChatUserId: patientId,
                        second_user_id: patientId
                      })
                    }, 2000)
                  }
                }
              }
            };
            document.querySelector('#chat-message-reply-input').focus();
            document.querySelector('#chat-message-reply-submit').onclick = function (e) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              __self.msgValue = messageInputDom.value;
              var message = __self.msgValue;
              var msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
              if (msg !== "") {
                var sentUserInfo = __self.chateRoomIdOfPateint;
                const currentUserId = localStorage.getItem('LoginedUserID');
                const payload = {
                  toUserID: sentUserInfo.id,
                  second_user_id: sentUserInfo.id,
                  fromUserID: currentUserId,
                  chatRoomId: createdRoomChatId,
                  senderMsgData: message,
                  msgSenderFullName: __self.selfUserInfo.first_name + ' ' + __self.selfUserInfo.last_name
                };
                let sentData = {
                  'message': message,
                  email: sentUserInfo.email,
                  senderID: sentUserInfo.id,
                  name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
                  selfUserID: __self.selfUserId,
                  is_read: false
                }
                videoSocketRef.emit({
                  type: "TypingEventForSelectedUser",
                  message: 'stop',
                  selfUserID:selfUserId,
                  targetForChatUserId: patientId,
                  second_user_id: patientId
                })
                clearTimeout(timeout)
                patientChatScoket.send(JSON.stringify({ 'message': message, 'user': sentUserInfo.id, 'chat_data': sentData }))
                let socketTimeout = setTimeout(function () {
                  bus.$emit('newChatMessage', payload);
                  clearTimeout(socketTimeout);
                }, 2000);
                messageInputDom.value = '';
                __self.msgValue = ''
              }
            };
          }, 200)
          // const [key, value] = Object.entries(this.patientChatDetailResults.slice(-1)[0]).pop();
          // console.log(value.slice(-1)[0])
          // for(const [key, value] of Object.entries(this.patientChatDetailResults)) {
          //   console.log(value.slice(-1)[0])
          // }
          // if (this.patientChatDetailResults.results){
          //   this.socketMsgReadFun(this.patientChatDetailResults[0].value.slice(-1)[0].id, chatForSelectedUserId)
          // }

          // Message Checking ON Live Socket
          patientChatScoket.onmessage = function (e) {
            var data = JSON.parse(e.data);
            var message = JSON.parse(data.message);
            var pchatmsg_recieved = document.createElement("div");
            var pchat_msg_item = document.createElement("div");
            var msg_time_wrp = document.createElement("span");
            var msg_time = document.createElement("time");
            msg_time_wrp.setAttribute("class", 'msg_time_wrp');
            msg_time.setAttribute("class", 'msg_time');
            pchat_msg_item.appendChild(document.createTextNode(message.chat_data.message));
            let dateTimeAdd = [moment(message.chat_data.current_time).format('h:mm a')];
            msg_time.appendChild(document.createTextNode(dateTimeAdd));
            msg_time_wrp.appendChild(msg_time);
            pchat_msg_item.appendChild(msg_time_wrp);
            pchatmsg_recieved.appendChild(pchat_msg_item);
            if(message.chat_data.selfUserID == __self.selfUserId){
              pchatmsg_recieved.setAttribute("class", 'append_pchatmsg pchatmsg_recieved');
              pchat_msg_item.setAttribute("class", "pchat_msg_item pchat_recieved_msg");
            }else{
              pchatmsg_recieved.setAttribute("class", 'append_pchatmsg pchatmsg_sent');
              pchat_msg_item.setAttribute("class", "pchat_msg_item pchat_send_msg");
            }
            messagesList.appendChild(pchatmsg_recieved);
            __self.chatScrollAlwaysBottomMethod()
          }
          patientChatScoket.onclose = function (e) {
            console.error("Socket Closed")
          }
        }).catch((err)=>{})
      })
    },
    chatScrollAlwaysBottomMethod(){
     setTimeout(()=>{
      var elmnt = document.getElementById("chat_msg_list_scroll");
      var y = elmnt.scrollHeight;
      $('#chat_msg_list_scroll').animate({ scrollTop: y }, 20)
     },100)
    },
    chatClosedMethod(){
      bus.$emit('chatInitWithPatientBus', true)
      if(patientChatScoket && patientChatScoket.readyState) {
        patientChatScoket.close();
      }
    }
  },
  watch:{
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
  }
}